import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/SquaresFour.es.js";
const r = o.forwardRef((e, a) => /* @__PURE__ */ o.createElement(s, { ref: a, ...e, weights: t }));
r.displayName = "SquaresFourIcon";
const n = r;
export {
  n as SquaresFour,
  r as SquaresFourIcon
};
